/**
 * Normaliza a E.164 boliviano (+591XXXXXXXX) el teléfono de CUALQUIER formulario de dirección.
 *
 * El input valida el formato pero no lo canoniza: `pattern="(\+?591)?[2-46-7][0-9]{6,7}"` acepta
 * "70904336" y "+59170904336" por igual. Guardar las dos formas obliga a cada consumidor a
 * normalizar por su cuenta.
 *
 * Eso es exactamente lo que hacía un Shopify Flow después de cada pedido: escribía el teléfono en
 * la NOTA del cliente, la volvía a leer, la parseaba con un `slice(0, 12)` y actualizaba el cliente
 * con `customerUpdate`. Dos consecuencias, las dos verificadas: ese `customerUpdate` **borraba las
 * direcciones del cliente**, y cuando el parseo fallaba escribía teléfonos de 5 dígitos — que dejan
 * la dirección "no válida" en el checkout y al comprador sin ningún método de envío.
 *
 * Normalizando acá, el teléfono queda canónico en la dirección desde que se carga. El ERP lo lee de
 * ahí (confirmado con el cliente el 2026-08-17), así que ya no hace falta escribir `customer.phone`
 * después del pedido — y `customerUpdate` es la ÚNICA forma de escribir ese campo, por lo que
 * sacarlo del camino elimina la causa del borrado.
 *
 * Se aplica a los cuatro formularios que existen: el popup del gate, la sección de direcciones de
 * la cuenta, el editor de dirección predeterminada y el listado de direcciones.
 */
(function () {
  const COUNTRY = '591';
  const SELECTOR = 'input[name="address[phone]"]';
  /** Fijos bolivianos: 7 dígitos. Celulares: 8. */
  const MIN_LOCAL = 7;
  const MAX_LOCAL = 8;

  /**
   * Devuelve el teléfono como +591XXXXXXXX, o el valor original si no lo reconoce.
   *
   * Nunca inventa un número: si no encaja en ninguna forma conocida se devuelve tal cual y lo
   * rechaza la validación del propio input. Guardar algo inventado es peor que rechazarlo — un
   * teléfono truncado pasa desapercibido hasta que rompe el checkout.
   */
  function normalize(raw) {
    const value = (raw || '').trim();
    if (!value) return value;

    const digits = value.replace(/\D/g, '');
    if (!digits) return value;

    // Ya trae el código de país. Los locales nunca empiezan con 5, así que no hay ambigüedad.
    if (digits.indexOf(COUNTRY) === 0) {
      const local = digits.slice(COUNTRY.length);
      if (local.length >= MIN_LOCAL && local.length <= MAX_LOCAL) return '+' + digits;
      return value;
    }

    if (digits.length >= MIN_LOCAL && digits.length <= MAX_LOCAL) return '+' + COUNTRY + digits;

    return value;
  }

  function apply(input) {
    if (!input || !input.value) return;
    const next = normalize(input.value);
    if (next !== input.value) input.value = next;
  }

  // El popup del gate se renderiza y re-renderiza dinámicamente, así que los listeners van
  // delegados en document en vez de atados a cada input.
  document.addEventListener(
    'change',
    (event) => {
      const target = event.target;
      if (target && target.matches && target.matches(SELECTOR)) apply(target);
    },
    true
  );

  // Red de seguridad: el autocompletado del navegador puede llenar el campo sin disparar `change`.
  // En fase de captura para correr antes que cualquier otro handler de submit del theme.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!form || !form.querySelectorAll) return;
      form.querySelectorAll(SELECTOR).forEach(apply);
    },
    true
  );
})();
